import type { WebGridColumn } from '../../webgrid/src';

/**
 * Creates a plain text WebGrid column whose dataIndex matches its key.
 *
 * Collapses the repeated `{ key, title, dataIndex, sortable, filterable }`
 * column literals shared across list pages (e.g. Storno.tsx, GoodsSale.tsx).
 * Sorting and filtering both default to enabled and can be overridden.
 */
export const createTextColumn = <T = Record<string, unknown>>(
    key: keyof T & string,
    title: string,
    options?: { sortable?: boolean; filterable?: boolean },
): WebGridColumn<T> => ({
    key,
    title,
    dataIndex: key,
    sortable: options?.sortable ?? true,
    filterable: options?.filterable ?? true,
});
